module.exports = {"150826100":"陕坝镇","150826101":"头道桥镇","150826102":"二道桥镇","150826103":"三道桥镇","150826104":"蛮会镇","150826105":"团结镇","150826106":"双庙镇","150826107":"沙海镇","150826108":"蒙海镇","150826500":"太阳庙农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150826.json
// module id = 419
// module chunks = 0